<template>
    <div class="app-container">
        <BjDivider right-fixed>{{ $t('billingPage.BillingInvoiceReport') }}</BjDivider>
        <el-form ref="reportRef" size="mini" :model="queryParams" class="bj-query-form bj-query-form-for-cal-height relative">
            <el-row :gutter="20">
                <!-- <el-col :span="colSpan">
                    <el-form-item :label="$t('dateText')">
                        <BjDateTimerangePicker v-model="queryParamsTime" :picker-options="pickerOptions" type="daterange" :clearable="false" format="dd/MM/yyyy" value-format="yyyy-MM-dd" :placeholder="$t('dateText')" />
                    </el-form-item>
                </el-col> -->
                <el-col :span="colSpan">
                    <el-form-item :label="$t('form.startDateText')">
                      <el-date-picker id="getWeekDate1" v-model="weekDataNow1" :picker-options="pickerOptions1" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="changeWeek1">
                      </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="colSpan">
                    <el-form-item :label="$t('form.endDateText')">
                      <el-date-picker id="getWeekDate2" v-model="weekDataNow2" :picker-options="pickerOptions2" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="changeWeek2">
                      </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col v-if="activeName != 'BillingPageInvoiceReportClientQty'" :span="colSpan">
                  <el-form-item :label="$t('billingPage.companySeller')" prop="clientCode">
                    <BjSelectLov v-model="queryParams.clientCode" :placeholder="$t('billingPage.companySeller')" :multiple="true" :option-list="clientCodeList" @change="changeClientCode" />
                  </el-form-item>
                </el-col>
                <el-col v-if="activeName == 'BillingPageInvoiceReportClient' || activeName =='BillingPageInvoiceReportPostage'" :span="colSpan">
                  <el-form-item :label="$t('billingPage.IRclientType')" prop="clientType">
                    <BjSelectLov v-model="queryParams.clientType" :placeholder="$t('billingPage.IRclientType')" :option-list="clientTypeList" @change="changeClientType" />
                  </el-form-item>
                </el-col>
                <el-col v-if="activeName == 'BillingPageInvoiceReportSales'" :span="colSpan">
                  <el-form-item :label="$t('billingPage.Sales')" prop="sales">
                    <BjSelectLov v-model="queryParams.sales" :placeholder="$t('billingPage.Sales')" multiple="true" :option-list="salesList" @change="changeSales" />
                  </el-form-item>
                </el-col>
            </el-row>
            <el-col :span="colSpan" style="position:absolute;bottom: 0;right:0;margin-bottom: 18px; display: flex; justify-content: flex-end">
                <el-button type="primary" plain @click="search">{{ $t('searchText') }}</el-button>
                <el-button type="default" plain @click="reset();search()">{{ $t('resetText') }}</el-button>
            </el-col>
        </el-form>
        <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
            <el-tab-pane v-for="item in BILLING_PAGE_INVOICE_REPORT_LIST" :key="item.value" :label="$t(`route.${item.value}`)" :name="item.value"></el-tab-pane>
        </el-tabs>

        <div v-if="isShow">
          <total v-if="activeName == 'BillingPageInvoiceReportTotal'" ref="totalRef" :chart-data="chartData" />
          <pallet v-if="activeName == 'BillingPageInvoiceReportPallet'" ref="palletRef" :chart-data="chartData" />
          <CBM v-if="activeName == 'BillingPageInvoiceReportCBM'" ref="CBMRef" :chart-data="chartData" />
          <clientqty v-if="activeName == 'BillingPageInvoiceReportClientQty'" ref="clientqtyRef" :chart-data="chartData" @sortChange="sortChange" />
          <client v-if="activeName == 'BillingPageInvoiceReportClient'" ref="clientRef" v-model="queryParams" @sortChange="sortChange" />
          <postage v-if="activeName == 'BillingPageInvoiceReportPostage'" ref="postageRef" v-model="queryParams" @sortChange="sortChange" />
          <sales v-if="activeName == 'BillingPageInvoiceReportSales'" ref="salesRef" v-model="queryParams" @sortChange="sortChange" />
        </div>
    </div>
</template>

<script>
import { BILLING_PAGE_INVOICE_REPORT_LIST } from '@/utils/constants';
import total from './total';
import pallet from './pallet';
import CBM from './CBM';
import clientqty from './clientqty';
import client from './client';
import postage from './postage';
import sales from './sales';
import moment from 'moment';
import { billApi } from '@/api';
const echarts = require('echarts/lib/echarts');

const start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 28);
const endWeek = `${moment().year()}-${moment().isoWeek().toString().padStart(2, '0')}`


const chartData = {
    // 线形图
    lineChartDataLine: {
      tooltip: {
        trigger: 'item',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        bottom: '-5',
      },
      xAxis: {
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        axisLabel: { interval: 0, rotate: 30 },
        axisLine: {
          show: false
        },
      },
      grid: {
        left: '-2%',
        right: 0,
        bottom: '-2%'
      },
      yAxis: {
        axisLine: {
          show: false
        },
      },
      series: [
        {
          name: 'ERP Avg Time',
          type: 'line',
          label: {
            show: true,
            position: 'top',
            textStyle: {
              color: '#ff1010',
            }
          },
          itemStyle: {
            color: '#ff1010',
          },
          smooth: false,
          areaStyle: {
              normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                          offset: 0,
                          color: 'rgba(255,16,16,0.3)'
                      },
                      {
                          offset: 1,
                          color: 'rgba(255,16,16,0)'
                      }
                  ], false),
              }
          },
          data: ['120', '132', '101', '134', '90', '230', '210']
        },
      ],
    },
    // 柱状图
    lineChartDataBar: {
      title: {
        text: 'Items',
        left: 'center',
        top: '0%'
      },
      grid: {
        containLabel: true
      },
      xAxis: {
        data: ['一', '二', '三', '四', '五'],
        axisLabel: { interval: 0, rotate: 30 },
      },
      yAxis: {},
      series: [
        {
          type: 'bar',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' }
              ])
            }
          },
          data: ['220', '182', '191', '234', '290']
        }
      ]
    },
    // 饼图
    lineChartDataPie: {
      title: {
        text: 'Percentage',
        left: 'center',
        top: '0%',
      },
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['0%', '50%'],
          label: {
            formatter: '{b}: {@2012} ({d}%)'
          },
          data: [
            { value: '1048', name: 'Search Engine' },
            { value: '735', name: 'Direct' },
            { value: '580', name: 'Email' },
            { value: '484', name: 'Union Ads' },
            { value: '300', name: 'Video Ads' }
          ]
        }
      ]
    },
};
moment.locale('en', {
    week: {
        dow: 1, // Sunday is the first day of the week
        doy: 4 // The week that contains Jan 4th is the first week of the year
    }
});
// 获取这周一的日期
const thisMonday = moment().startOf('week');
// 格式化日期为年-月-日
const thisMondayString = thisMonday.format('YYYY-MM-DD');
export default {
  name: 'BusinessBillingInvoiceReport',
  components: {
    total, pallet, CBM, clientqty, client, postage, sales
  },
  data() {
    return {
        colSpan: 4,
        queryParams: {
          startWeek: this.formatYeatWeek(thisMondayString, true),
          endWeek: endWeek,
          clientCode: [],
          clientType: null,
          sales: []
        },
        weekDataNow1: start,
        weekDataNow2: new Date(),
        activeName: 'BillingPageInvoiceReportTotal',
        BILLING_PAGE_INVOICE_REPORT_LIST,
        clientCodeList: [],
        clientTypeList: [
          {label: '2C', value: '2C'},
          {label: '2B', value: '2B'},
          {label: '2C&2B', value: '2C&2B'},
        ],
        chartData,
        salesList: [],
        isShow: true,
        pickerOptions1: {
          firstDayOfWeek: 1,
          disabledDate: (time) => {
            return time.getTime() > this.weekDataNow2;
          }
        },
        pickerOptions2: {
          firstDayOfWeek: 1,
          disabledDate: (time) => {
            return time.getTime() < this.weekDataNow1;
          }
        }
    };
  },
  created() {
    this.getClientInfoList();
    this._getAllSales();
  },
  mounted() {
    this.$nextTick(() => {
      this.search();
    });
  },
  methods: {
    changeWeek1() {
      this.$nextTick(() => {
        this.queryParams.startWeek = document.querySelector('#getWeekDate1').value;
      });

    },
    changeWeek2() {
      this.$nextTick(() => {
        this.queryParams.endWeek = document.querySelector('#getWeekDate2').value;
      });
    },
    formatYeatWeek(data, isLastWeek = false) {
      const momentDate = moment(data, 'YYYY-MM-DD');
      let year = momentDate.year();
      const isoWeek = momentDate.isoWeek();
      let lastWeekNumber = isoWeek - 4;
      if (isLastWeek) {
        if(lastWeekNumber < 0){
          year -= 1;
          lastWeekNumber += 52
        }
        return `${year}-${String(lastWeekNumber).padStart(2, '0')}`; // 使用padStart确保周数总是两位数
      }
      // let weekNumber = momentDate.week(); // 这将返回一个介于1到52（或53，如果那年有53周）之间的数字
      // // 如果你想要遵循ISO 8601标准（即周一为每周的第一天，并且每年第一周必须包含当年的1月4日），你可以这样做：
      const isoWeekNumber = momentDate.isoWeek();
      return `${year}-${isoWeekNumber.toString().padStart(2, '0')}`;
    },
    _getAllSales() {
      billApi.getAllSales().then(res => {
        this.salesList = res.data;
      });
    },
    // 获取所有客户信息列表
    getClientInfoList() {
      billApi.getClientInfoList().then(res => {
        res.data.forEach(item => {
          item.label = `${item.label} - ${item.value}`;
        });
        this.clientCodeList = res.data;
      });
    },
    tabClick(e) {
      this.queryParams = {
        ...this.queryParams,
        clientCode: [],
        clientType: null,
        sales: []
      };
      this.activeName = e.name;
      this.$nextTick(() => {
        this.search();
      });
    },
    search() {
      this.isShow = false;
      switch (this.activeName) {
        case 'BillingPageInvoiceReportTotal':
          this.$refs.totalRef.init(this.queryParams);
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportPallet':
          this.$refs.palletRef.init(this.queryParams);
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportCBM':
          this.$refs.CBMRef.init(this.queryParams);
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportClientQty':
          this.$refs.clientqtyRef.init(this.queryParams);
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportClient':
          this.$refs.clientRef.queryParams = this.queryParams;
          this.$refs.clientRef.$refs.BjPage.fetchData();
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportPostage':
          this.$refs.postageRef.queryParams = this.queryParams;
          this.$refs.postageRef.$refs.BjPage.fetchData();
          this.isShow = true;
          break;
        case 'BillingPageInvoiceReportSales':
          this.$refs.salesRef.queryParams = this.queryParams;
          this.$refs.salesRef.$refs.BjPage.fetchData();
          this.isShow = true;
          break;
      }
    },
    reset() {
      this.weekDataNow1 = start;
      this.weekDataNow2 = new Date();
      this.queryParams = {
        startWeek: this.formatYeatWeek(thisMondayString, true),
        endWeek: endWeek,
        clientCode: [],
        sales: [],
        clientType: null
      };
      this.$refs.reportRef.resetFields();
    },
    changeClientCode(val) {
      if (val.length > 0) {
        this.queryParams.clientType = '';
        this.queryParams.sales = [];
      }
    },
    changeClientType(val) {
      if (val) {
        this.queryParams.clientCode = [];
      }
    },
    changeSales(val) {
      if (val.length > 0) {
        this.queryParams.clientCode = [];
      }
    },
    sortChange(column) {
      this.queryParams.sortedFields = `${column.field} ${String(column.order).toUpperCase()}`;
      this.search();
    }
  }
};
</script>
